import * as React from 'react';
import Box from '../../../parts/Box';
import {ll_url} from '../../../tools';

import {
    IInputComponentPropsData,
    IInputComponentPropsFunctions,
} from '../props/IInputComponentProps';
import {
    IInputJobSettings2PropsData,
    IInputJobSettings2PropsFunctions,
} from '../props/IInputJobSettings2Props';
import {
    ISummaryComponentPropsData,
    ISummaryComponentPropsFunctions,
} from '../../SummaryPage/props/ISummaryComponentProps';
import {
    IInputJobSettingsPropsData,
    IInputJobSettingsPropsFunctions,
} from '../props/IInputJobSettingsProps';
import {
    IConstructionOfSeqDatasetPropsData,
    IConstructionOfSeqDatasetPropsFunctions,
} from '../props/IConstructionOfSeqDatasetProps';

import TableEssentialResidues from './TableEssentialResiduesComponent';

import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import ConstructionOfSeqDatasetContainer from '../containers/constructionOfSeqDatasetContainer';
import IdentificationOfConsensusResiduesContainer from '../containers/identificationOfConsensusResiduesContainer';
import ThresholdSettingContainer from '../containers/ThresholdSettingsContainer';
import AnalysisOfCorrelatedPositions from '../containers/analysisOfCorrelatedPositionsContainer';

import { columnsEssentialResidues } from '../../../TableColumns';
import TableEssentialResiduesContainer from '../containers/TableEssentialResiduesContainer';

import { SiteAnnotation } from '../../../IMainState';

type IProps = IInputJobSettings2PropsData &
    IInputJobSettings2PropsFunctions &
    IConstructionOfSeqDatasetPropsData &
    IConstructionOfSeqDatasetPropsFunctions &
    IInputJobSettingsPropsData &
    IInputJobSettingsPropsFunctions &
    IInputComponentPropsData &
    IInputComponentPropsFunctions &
    IInputComponentPropsFunctions &
    ISummaryComponentPropsData &
    ISummaryComponentPropsFunctions & { history: any };

export default class InputJobSettings_2 extends React.Component<IProps> {
    infoRef = React.createRef<HTMLFormElement>();

    state = {
        ShowAdvanced: false,
        AgregatedSitesAnnotations: [],
        selectedChain: "",
        selectedAA: "",
        currentAAs: [],
        description: "",
        type: "",
    };
    handleShowAdvanced = () => {
        localStorage.User = JSON.stringify(true);
        this.setState({
            ShowAdvanced: !this.state.ShowAdvanced,
        });
    };

    handleSubmit = () => {
        if(this.props.selectedSitesAnnotations == null || this.props.selectedSitesAnnotations.size == 0){
            if(window.confirm("No essential residues were selected to be excluded from further calculation. Is that OK?")){
                this.props.submitInput();
            }
        }
        else{
            this.props.submitInput();
        }
    };

    componentDidMount() {
        this.computeChain(null);
        this.props.getSiteAnotations(this.props.jobId, this.props.sequence, this.props.inputDataType);
    }

    computeChain = (value) => {

        if(!value){
            Object.keys(this.props.indexes).map((chain) => (
                value == null ? value = chain : value = value
            )) 
        }

        var seq = "";
        var offset = 0;
        var counter = 0;
        var aas = [];

        Object.keys(this.props.indexes[value]).map((idx) => (
            aas.push(this.props.sequence.charAt(Number(idx)) + this.props.indexes[value][idx])
        ));

        var selAA = "";
        Object.keys(this.props.indexes[value]).map((idx) => (
            selAA == "" ? selAA = this.props.sequence.charAt(Number(idx)) + this.props.indexes[value][idx] : selAA = selAA
        ));

        this.setState({
            selectedChain: value,
            currentAAs: aas,
            selectedAA: selAA,
        });
    }

    handleSelectChain = (ev) => {

        const value = ev.target.value;

        this.computeChain(value);
    }

    handleSelectAA = (ev) => {
        const value = ev.target.value;
        this.setState({
            selectedAA: value,
        });
    }

    handleAddResidue = () => {

        const residue : SiteAnnotation = {
            chain: this.state.selectedChain,
            residueName: this.state.selectedAA.charAt(0),
            residue: Number(this.state.selectedAA.substring(1)),
            referenceEntry: "-",
            identity: 0,
            type: this.state.type,
            description: this.state.description,
            neighbourhood: null,
        };

        this.props.addUserResidue(residue);

        this.setState({
            type: "",
            description: "",
        });
    }

    handleChangeDescription = (ev) => {
        const value = ev.target.value;
        this.setState({
            description: value,
        });
    }

    handleChangeType = (ev) => {
        const value = ev.target.value;
        this.setState({
            type: value,
        });
    }

    /*---------------------------------------------------------------------------------------------------------------------------------- */
    render() {
        return (

            <div>
                <Form style={{ display: 'flex', justifyContent: 'end' }}>
                    <FormGroup check inline>
                        <Input type='checkbox' onClick={this.handleShowAdvanced} />
                        <Label check>Advanced settings</Label>
                    </FormGroup>
                </Form>
                <Box title='ESSENTIAL RESIDUES'>
                    <Form>
                    <Row><Col>
                        { !this.props.showWaitingMSG ? null :
                            <Label waiting><img src ={ll_url("/images/working.gif")} /> SwisProt database is being searched to identify essential residues. It can take several minutes...</Label>
                        }
                    </Col></Row>
                    </Form>

                    <Row>
                    <Col xs={8}>
                    <TableEssentialResiduesContainer
                        PositionSpecificData={this.props.sitesAnotations.filter(
                            (v, i, a) =>
                                a.findIndex(
                                    (v2) => ['chain', 'residue'].every((k) => v2[k] === v[k]) // TODO ['chain','residue'] (now backend doesn't return chain)
                                ) === i
                        )}
                        AllEssentialResiduesData={this.props.sitesAnotations}
                    />
                    </Col>
                    <Col>
                        <Row><Col><Label>Chain: </Label></Col>
                        
                        <Col><select value={this.state.selectedChain} onChange={this.handleSelectChain} style={{width: '100px'}}>
                            {
                                Object.keys(this.props.indexes).map((chain) => (
                                    <option value={chain}>{chain}</option>
                                ))
                            }
                        </select></Col></Row>
                        <Row><Col><Label>Residue: </Label></Col>
                        <Col><select value={this.state.selectedAA} onChange={this.handleSelectAA} style={{width: '100px'}}>
                            {                           
                                this.state.currentAAs.map((res) => (
                                    <option value={res}>{res}</option> 
                                ))
        
                            }
                        </select></Col></Row>
                        <Row><Col><Label>Type: </Label></Col>
                        <Col><input className="form-control" type="text" value={this.state.type} onChange={this.handleChangeType} style={{width: '100px'}} /></Col></Row>
                        <Row><Col><Label>Description: </Label></Col></Row>
                        <Row><Col><textarea className="form-control" id="w3review" value={this.state.description} onChange={this.handleChangeDescription} style={{width: '260px'}} /></Col></Row>
                        <Row><Col><Button onClick={this.handleAddResidue}>
                        Add residue
                        </Button></Col></Row>
                    </Col>
                    </Row>
                </Box>

                {!this.state.ShowAdvanced ? null : (
                    <div>
                        <ConstructionOfSeqDatasetContainer {...this.props} />
                        <IdentificationOfConsensusResiduesContainer {...this.props} />
                        <ThresholdSettingContainer {...this.props} />
                        <AnalysisOfCorrelatedPositions {...this.props} />
                    </div>
                )}

                <div className='ll-button-group'>
                    <Button size='lg' onClick={this.props.goBack}>
                        Back
                    </Button>
                    <Button
                        style={{ marginLeft: '5px' }}
                        size='lg'
                        onClick={this.handleSubmit}>
                        Next
                    </Button>
                </div>
            </div>
        );
    }
}
